module.exports = __webpack_public_path__ + "static/media/deltadental.a219d477.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/partner/logos/deltadental.png
// module id = 32
// module chunks = 0